/**
 * **Der Ausschnitt fährt mit**, wenn eine Geste an den Rand kommt — dieselbe
 * Rechnung, die React Flow beim Ziehen einer Notiz anstellt
 * (`calcAutoPan` in @xyflow/system, `autoPanOnNodeDrag`). Hier
 * nachgebaut, weil @xyflow/system keine direkte Abhängigkeit ist und die
 * Zahlen (40px Zone, Geschwindigkeit 15) sich nicht unbemerkt von React
 * Flows eigenem Verhalten entfernen sollen: Wer mit dem **Tauschpunkt**
 * an den Rand fährt, soll dasselbe spüren wie beim Verschieben.
 *
 * Bewusst ohne React-Bezug, wie die übrigen `utils/`.
 */

/** Wie nah am Rand (in Bildschirm-Pixeln) das Fahren beginnt. */
export const AUTO_PAN_DISTANCE = 40
/** Bildschirm-Pixel je Frame ganz außen — React Flows `autoPanSpeed`. */
export const AUTO_PAN_SPEED = 15

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max)

/** Anteil der Kraft (−1…1) auf einer Achse: innerhalb der Zone wächst er linear zur Kante. */
function velocity(value: number, min: number, max: number): number {
  if (value < min) return clamp(Math.abs(value - min), 1, min) / min
  if (value > max) return -clamp(Math.abs(value - max), 1, min) / min
  return 0
}

/**
 * Um wie viele Bildschirm-Pixel der Ausschnitt in diesem Frame rückt.
 *
 * Das Vorzeichen ist das von React Flows `panBy`: Steht der Zeiger rechts,
 * wandert der Ausschnitt nach links (negativ), und rechts kommt Neues ins
 * Bild.
 *
 * @param pointer der Zeiger, relativ zur linken oberen Ecke des Canvas
 * @param bounds  die Maße des Canvas auf dem Bildschirm
 */
export function autoPanDelta(
  pointer: { x: number; y: number },
  bounds: { width: number; height: number },
  speed = AUTO_PAN_SPEED,
): { x: number; y: number } {
  return {
    x: velocity(pointer.x, AUTO_PAN_DISTANCE, bounds.width - AUTO_PAN_DISTANCE) * speed,
    y: velocity(pointer.y, AUTO_PAN_DISTANCE, bounds.height - AUTO_PAN_DISTANCE) * speed,
  }
}
